import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

import { PaymentIcon, PaymentType } from '@thg-commerce/enterprise-config'

import {
  BasketMessageType,
  Country,
  Currency,
  RichContentType,
} from '../../../../generated/graphql'
import { ClientBehaviours } from '../../../utils'
import { Basket as query } from '../../../../graphql/Query/Basket/Basket.graphql'
import {
  normaliseBasket,
  NormalisedBasket,
} from '../../../../transformers/basket'
import { DescriptionKeys } from '../../../../transformers/product/description'

export type BasketData = NormalisedBasket

export interface BasketVariables {
  id?: string
  shippingDestination: Country
  currency: Currency
  productDescriptionKeys?: DescriptionKeys
  productContentKeys?: string[]
  wishlistEnabled?: boolean
  loyaltyEnabled?: boolean
  clickAndCollectEnabled?: boolean
}

// export const BASKET_MOCK_OLD: BasketData = {
//   id: '3ea08305-eb71-4896-9ee6-d2be504268e8:1655404004656',
//   totalQuantity: 107,
//   appliedOffers: [
//     {
//       message: 'Enjoy 20% off!',
//       removeable: true,
//       amount: '795.60',
//       displayValue: '£795.60',
//       __typename: 'AppliedOffer',
//     },
//   ],
//   standardPrice: {
//     amount: '2000.00',
//     __typename: 'MoneyValue',
//   },
//   discount: {
//     displayValue: '£24.02',
//       amount: '24.02',
//   },
//   items: [
//     {
//       id: '1',
//       fulfilmentMethod: FulfilmentMethod.HomeDelivery,
//       product: {
//         sku: 11450894,
//         inStock: true,
//         title:
//           'Bioderma Sensibio H2O Make-Up Removing Solution Sensitive Skin 250ml',
//         maxPerOrder: 5,
//         product: {
//           sku: 11450894,
//           variants: [
//             {
//               sku: 11450894,
//               __typename: 'ProductVariant',
//             },
//             {
//               sku: 11450895,
//               __typename: 'ProductVariant',
//             },
//           ],
//           url:
//             '/bioderma-sensibio-h2o-make-up-removing-solution-sensitive-skin-250ml/11450894.html',
//           images: [
//             {
//               largeProduct:
//                 'https://gb2-st-cdn-001.io.thehut.local/productimg/70/70/11450894-1184572660590193.jpg',
//               __typename: 'ProductImage',
//             },
//           ],
//           brand: { name: 'MyProtein', __typename: 'Brand' },
//           __typename: 'Product',
//         },
//         inWishlist: false,
//         __typename: 'ProductVariant',
//       },
//       quantity: 3,
//       appliedOffers: [],
//       standardPricePerUnit: {
//         amount: '7.13',
//         displayValue: '£7.13',
//         __typename: 'MoneyValue',
//       },
//       totalChargePrice: {
//         amount: '7.13',
//         displayValue: '£7.13',
//         __typename: 'MoneyValue',
//       },
//       totalDiscount: {
//         displayValue: '£0.00',
//         __typename: 'MoneyValue',
//       },
//       totalStandardPrice: {
//         displayValue: '£7.13',
//         amount: '7.13',
//         __typename: 'MoneyValue',
//       },
//       freeGift: false,
//       messages: [
//         {
//           type: BasketItemMessageType.FulfilmentIssue,
//           __typename: 'BasketItemMessage',
//         },
//         {
//           type: BasketItemMessageType.ProductIssue,
//           __typename: 'BasketItemMessage',
//         },
//       ],
//       __typename: 'BasketItem',
//     },
//     {
//       id: '2',
//       fulfilmentMethod: FulfilmentMethod.CollectInStore,
//       product: {
//         sku: 11640991,
//         inStock: true,
//         title: 'NARS Cosmetics Radiant Creamy Concealer - Cafe Con Leche',
//         maxPerOrder: 4,
//         product: {
//           sku: 11640991,
//           variants: [
//             {
//               sku: 11640991,
//               __typename: 'ProductVariant',
//             },
//             {
//               sku: 11640992,
//               __typename: 'ProductVariant',
//             },
//           ],
//           url:
//             '/nars-cosmetics-radiant-creamy-concealer-cafe-con-leche/11640991.html',
//           images: [
//             {
//               largeProduct:
//                 'https://gb2-st-cdn-001.io.thehut.local/productimg/70/70/11640991-1794538218493133.jpg',
//               __typename: 'ProductImage',
//             },
//           ],
//           brand: { name: 'MyProtein', __typename: 'Brand' },
//           __typename: 'Product',
//         },
//         inWishlist: true,
//         __typename: 'ProductVariant',
//       },
//       quantity: 4,
//       appliedOffers: [
//         {
//           message: 'Enjoy 3 for 2 across selected products',
//           info: '',
//           totalBasketDiscount: {
//             displayValue: '£24.00',
//             __typename: 'MoneyValue',
//           },
//           __typename: 'AppliedOffer',
//         },
//         {
//           message: 'Staff discount - Enjoy 25% off!',
//           info: '',
//           totalBasketDiscount: {
//             displayValue: '£24.00',
//             __typename: 'MoneyValue',
//           },
//           __typename: 'AppliedOffer',
//         },
//       ],
//       standardPricePerUnit: {
//         amount: '24.00',
//         displayValue: '£24.00',
//         __typename: 'MoneyValue',
//       },
//       totalChargePrice: {
//         amount: '24.00',
//         displayValue: '£24.00',
//         __typename: 'MoneyValue',
//       },
//       totalDiscount: {
//         displayValue: '£24.00',
//         __typename: 'MoneyValue',
//       },
//       totalStandardPrice: {
//         displayValue: '£48.00',
//         amount: '48.00',
//         __typename: 'MoneyValue',
//       },
//       freeGift: false,
//       messages: [
//         {
//           type: BasketItemMessageType.FulfilmentIssue,
//           __typename: 'BasketItemMessage',
//         },
//         {
//           type: BasketItemMessageType.ProductIssue,
//           __typename: 'BasketItemMessage',
//         },
//         {
//           type: BasketItemMessageType.NotEnoughStock,
//           __typename: 'BasketItemMessage',
//         },
//       ],
//       __typename: 'BasketItem',
//     },
//     {
//       id: '3',
//       fulfilmentMethod: FulfilmentMethod.HomeDelivery,
//       product: {
//         sku: 11640991,
//         inStock: true,
//         title: 'NARS Cosmetics Radiant Creamy Concealer - Cafe Con Leche',
//         maxPerOrder: 10,
//         product: {
//           sku: 11640991,
//           variants: [
//             { sku: 11640991, __typename: 'ProductVariant' },
//             { sku: 11640992, __typename: 'ProductVariant' },
//           ],
//           url:
//             '/nars-cosmetics-radiant-creamy-concealer-cafe-con-leche/11640991.html',
//           images: [
//             {
//               largeProduct:
//                 'https://gb2-st-cdn-001.io.thehut.local/productimg/70/70/11640991-1794538218493133.jpg',
//               __typename: 'ProductImage',
//             },
//           ],
//           brand: { name: 'MyProtein', __typename: 'Brand' },
//           __typename: 'Product',
//         },
//         inWishlist: false,
//         __typename: 'ProductVariant',
//       },
//       quantity: 1,
//       appliedOffers: [],
//       standardPricePerUnit: {
//         amount: '356.00',
//         displayValue: '£356.00',
//         __typename: 'MoneyValue',
//       },
//       totalChargePrice: {
//         displayValue: '£356.00',
//         amount: '356.00',
//         __typename: 'MoneyValue',
//       },
//       totalDiscount: {
//         displayValue: '£0.01',
//         __typename: 'MoneyValue',
//       },
//       totalStandardPrice: {
//         displayValue: '£356.00',
//         amount: '356.00',
//         __typename: 'MoneyValue',
//       },
//       freeGift: false,
//       messages: [],
//       __typename: 'BasketItem',
//     },
//     {
//       id: '4',
//       fulfilmentMethod: FulfilmentMethod.DeliverToStore,
//       product: {
//         sku: 11640991,
//         inStock: true,
//         title: 'NARS Cosmetics Radiant Creamy Concealer - FREE ITEM',
//         maxPerOrder: null,
//         product: {
//           sku: 11640991,
//           variants: [
//             {
//               sku: 11640991,
//               __typename: 'ProductVariant',
//             },
//             {
//               sku: 11640992,
//               __typename: 'ProductVariant',
//             },
//           ],
//           url:
//             '/nars-cosmetics-radiant-creamy-concealer-cafe-con-leche/11640991.html',
//           images: [
//             {
//               largeProduct:
//                 'https://gb2-st-cdn-001.io.thehut.local/productimg/70/70/11640991-1794538218493133.jpg',
//               __typename: 'ProductImage',
//             },
//           ],
//           brand: { name: 'MyProtein', __typename: 'Brand' },
//           __typename: 'Product',
//         },
//         inWishlist: false,
//         __typename: 'ProductVariant',
//       },
//       quantity: 99,
//       appliedOffers: [
//         {
//           message: 'Enjoy 3 for 2 across selected products',
//           info: '',
//           totalBasketDiscount: {
//             displayValue: '£24.00',
//             __typename: 'MoneyValue',
//           },
//           __typename: 'AppliedOffer',
//         },
//       ],
//       standardPricePerUnit: {
//         amount: '0.01',
//         displayValue: '£0.01',
//         __typename: 'MoneyValue',
//       },
//       totalChargePrice: {
//         displayValue: '£0.00',
//         amount: '0',
//         __typename: 'MoneyValue',
//       },
//       totalDiscount: {
//         displayValue: '£0.01',
//         __typename: 'MoneyValue',
//       },
//       totalStandardPrice: {
//         displayValue: '£0.01',
//         amount: '0.01',
//         __typename: 'MoneyValue',
//       },
//       freeGift: true,
//       messages: [
//         {
//           type: BasketItemMessageType.FulfilmentIssue,
//           __typename: 'BasketItemMessage',
//         },
//         {
//           type: BasketItemMessageType.ProductIssue,
//           __typename: 'BasketItemMessage',
//         },
//       ],
//       __typename: 'BasketItem',
//     },
//   ],
//   chargePrice: {
//     amount: '31.13',
//     displayValue: '£31.13',
//     __typename: 'MoneyValue',
//   },
//   earnableLoyaltyPoints: 568,
//   recommendations: [
//     {
//       sku: 10970368,
//       title: 'NEOM Real Luxury De-Stress Travel Scented Candle',
//       price: '£12.80',
//       url: '/neom-real-luxury-de-stress-travel-scented-candle/10970368.html',
//       image:
//         'https://s1.thcdn.com/productimg/300/300/10970368-2144928009558577.jpg',
//       reviews: {
//         total: 4.6,
//         averageScore: 10,
//         __typename: 'ProductReviews',
//       },
//       __typename: 'Product',
//     },
//     {
//       sku: 13327404,
//       title: 'NEOM Super Shower Power Body Cleanser 50ml',
//       price: '£6.93',
//       url: '/neom-super-shower-power-body-cleanser-50ml/13327404.html',
//       image:
//         'https://s1.thcdn.com/productimg/300/300/13327404-6044928012968587.jpg',
//       reviews: {
//         total: 0,
//         averageScore: 0,
//         __typename: 'ProductReviews',
//       },
//       __typename: 'Product',
//     },
//   ],
//   messages: [
//     {
//       type: BasketMessageType.Upsell,
//       message: 'Myprotein Metal Shaker only £5',
//       __typename: 'BasketMessage',
//     },
//     {
//       type: BasketMessageType.CodeInvalid,
//       message: 'The discount code you entered is not an active offer.',
//       __typename: 'BasketMessage',
//     },
//     {
//       type: BasketMessageType.CodeApplied,
//       message: '4 FREE gifts on £100 spend',
//       __typename: 'BasketMessage',
//     },
//   ],
//   selectYourSample: [
//     {
//       id: '882240',
//       title: '2 FREE gifts on ALL orders',
//       message: 'Up to 3 FREE Gifts over £20',
//       currentAmountSpent: {
//         displayValue: '£3.34',
//         amount: '3.34',
//         __typename: 'MoneyValue',
//       },
//       tiers: [
//         {
//           id: '882240:0',
//           isFullyOutOfStock: false,
//           isPartiallyOutOfStock: false,
//           additionalSpendToReach: {
//             displayValue: '£0.00',
//             amount: '0.00',
//             __typename: 'MoneyValue',
//           },
//           thresholdAmountSpent: {
//             displayValue: '£0.00',
//             __typename: 'MoneyValue',
//           },
//           products: [
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Chip £10 Credit to New Accounts',
//               sku: 12948578,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'SimplyCook Free Trial',
//               sku: 12948573,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Impact EAA Stick Pack (Sample) 7g Unflavoured',
//               sku: 12067981,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//           ],
//           selectedProducts: [
//             {
//               sku: 12948578,
//               __typename: 'ProductVariant',
//             },
//           ],
//           maxSelectedProducts: 2,
//           __typename: 'SelectYourSampleTier',
//         },
//         {
//           id: '882240:1',
//           isFullyOutOfStock: false,
//           isPartiallyOutOfStock: true,
//           additionalSpendToReach: {
//             displayValue: '£1.00',
//             amount: '0',
//             __typename: 'MoneyValue',
//           },
//           thresholdAmountSpent: {
//             displayValue: '£0.99',
//             __typename: 'MoneyValue',
//           },
//           products: [
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'The Supplement Magazine: Reboot Issue',
//               sku: 13438110,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/13438110-1384920294526248.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/13438110-1384920294526248.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/13438110-1384920294526248.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Chip - £10 Credit to New Accounts',
//               sku: 12948578,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: false,
//               __typename: 'ProductVariant',
//             },
//           ],
//           selectedProducts: [],
//           maxSelectedProducts: 1,
//           __typename: 'SelectYourSampleTier',
//         },
//         {
//           id: '882240:2',
//           isFullyOutOfStock: true,
//           isPartiallyOutOfStock: false,
//           additionalSpendToReach: {
//             displayValue: '£100',
//             amount: '0',
//             __typename: 'MoneyValue',
//           },
//           thresholdAmountSpent: {
//             displayValue: '£0.00',
//             __typename: 'MoneyValue',
//           },
//           products: [
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Chip £10 Credit to New Accounts',
//               sku: 12948578,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: false,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'SimplyCook Free Trial',
//               sku: 12948573,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: false,
//               __typename: 'ProductVariant',
//             },
//           ],
//           selectedProducts: [],
//           maxSelectedProducts: 2,
//           __typename: 'SelectYourSampleTier',
//         },
//       ],
//       __typename: 'SelectYourSample',
//     },
//     {
//       id: '882241',
//       title: '3 FREE gifts on ALL orders',
//       message: 'Up to 3 FREE Gifts over £20',
//       currentAmountSpent: {
//         displayValue: '£3.34',
//         amount: '3.34',
//         __typename: 'MoneyValue',
//       },
//       tiers: [
//         {
//           id: '882241:0',
//           isFullyOutOfStock: false,
//           isPartiallyOutOfStock: false,
//           additionalSpendToReach: {
//             displayValue: '£0.00',
//             amount: '0',
//             __typename: 'MoneyValue',
//           },
//           thresholdAmountSpent: {
//             displayValue: '£0.00',
//             __typename: 'MoneyValue',
//           },
//           products: [
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Chip £10 Credit to New Accounts',
//               sku: 12948578,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'SimplyCook Free Trial',
//               sku: 12948573,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//             {
//               images: [
//                 {
//                   thumbnail:
//                     'https://s1.thcdn.com/productimg/70/70/12948579-2094876748642871.jpg',
//                   largeProduct:
//                     'https://s1.thcdn.com/productimg/300/300/12948579-2094876748642871.jpg',
//                   zoom:
//                     'https://s1.thcdn.com/productimg/960/960/12948579-2094876748642871.jpg',
//                   __typename: 'ProductImage',
//                 },
//               ],
//               title: 'Impact EAA Stick Pack (Sample) 7g Unflavoured',
//               sku: 12067981,
//               content: [
//                 {
//                   key: 'synopsis',
//                   value: {
//                     richContentListValue: [
//                       {
//                         content: [
//                           {
//                             content:
//                               '<p>Save 50% off food at 1000’s of UK restaurants including Prezzo, Zizzi, Ask Italian, Bella Italia &amp; more. We’ve teamed up with tastecard to give you access to a FREE 90-day trial where you can sign up in minutes and cancel at any time.</p> \n<p>tastecard is the UK’s largest diners club. Over the past 15 years they have helped over 2 million members save money on the things they love.</p> \n<p><strong>The offers included in a FREE 90-day tastecard trial are:</strong></p> \n<ul> \n <li>2 for 1 meals or 50% off food at 1000’s of UK restaurants</li> \n <li>50% off Pizza Delivery with Pizza Hut Delivery &amp; Domino’s</li> \n <li>Up to 30% off online movies &amp; cinema tickets</li> \n <li>Up to 50% off attractions</li> \n <li>Save at least 10% on Delivery &amp; Collection</li> \n</ul> \n<p><em>&nbsp;*Terms and conditions apply. For more information, please see https://www.tastecard.co.uk/terms-and-conditions. 90-day free trial auto renews into a £5.99 monthly membership, cancel at any time. 50% off Domino’s available in select locations.</em></p>',
//                             type: RichContentType.Html,
//                             __typename: 'RichContentItem',
//                           },
//                         ],
//                         __typename: 'RichContent',
//                       },
//                     ],
//                     __typename: 'ProductContentRichContentListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//                 {
//                   key: 'brand',
//                   value: {
//                     stringListValue: ['Myprotein'],
//                     __typename: 'ProductContentStringListValue',
//                   },
//                   __typename: 'ProductContentItem',
//                 },
//               ],
//               inStock: true,
//               __typename: 'ProductVariant',
//             },
//           ],
//           selectedProducts: [
//             {
//               sku: 12948578,
//               __typename: 'ProductVariant',
//             },
//           ],
//           maxSelectedProducts: 2,
//           __typename: 'SelectYourSampleTier',
//         },
//       ],
//       __typename: 'SelectYourSample',
//     },
//   ],
//   hasProductWithClickAndCollectFulfilment: true,
//   availablePaymentOptions: [
//     {
//       type: PaymentType.KLARNA,
//       subType: null,
//       icon: PaymentIcon.KLARNA,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.PAYPAL,
//       subType: null,
//       icon: PaymentIcon.PAYPAL,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.ZIP_PAY,
//       subType: null,
//       icon: PaymentIcon.ZIP_PAY,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.WE_CHAT_PAY,
//       subType: null,
//       icon: PaymentIcon.WE_CHAT_PAY,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.ALI_PAY_PLUS,
//       subType: null,
//       icon: PaymentIcon.ALI_PAY_PLUS,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.ATOME,
//       subType: null,
//       icon: PaymentIcon.ATOME,
//       __typename: 'AvailablePaymentOption',
//     },
//     {
//       type: PaymentType.SPOTII,
//       subType: null,
//       icon: PaymentIcon.SPOTII,
//       __typename: 'AvailablePaymentOption',
//     },
//   ],
//   __typename: 'Basket',
// }

export const BASKET_MOCK: BasketData = {
  id: '3ea08305-eb71-4896-9ee6-d2be504268e8:1655404004656',
  totalQuantity: 3,
  standardPrice: {
    amount: '67.97',
    __typename: 'MoneyValue',
  },
  appliedOffers: [
    {
      displayValue: '£11.50',
      amount: '11.50',
      message: "You've saved 50%",
      removeable: false,
      __typename: 'AppliedOffer',
    },
    {
      displayValue: '£0.00',
      amount: '0.00',
      message: '3 FREE gifts on all orders',
      removeable: false,
      __typename: 'AppliedOffer',
    },
  ],
  discount: {
    displayValue: '£10.50',
    amount: '10.50',
    __typename: 'MoneyValue',
  },
  items: [
    {
      id: '13661766',
      fulfilmentMethod: null,
      product: {
        sku: 13661766,
        title: 'Layered Protein Bar - 6 x 60g - Vanilla Birthday Cake - NEW',
        maxPerOrder: null,
        product: {
          sku: 12116519,
          url: '/sports-nutrition/layered-protein-bar/12116519.html',
          variants: [
            {
              sku: 12116523,
              __typename: 'ProductVariant',
            },
            {
              sku: 12239406,
              __typename: 'ProductVariant',
            },
            {
              sku: 12506110,
              __typename: 'ProductVariant',
            },
            {
              sku: 12608526,
              __typename: 'ProductVariant',
            },
            {
              sku: 12748396,
              __typename: 'ProductVariant',
            },
            {
              sku: 13030843,
              __typename: 'ProductVariant',
            },
            {
              sku: 13477704,
              __typename: 'ProductVariant',
            },
            {
              sku: 13661760,
              __typename: 'ProductVariant',
            },
            {
              sku: 13661766,
              __typename: 'ProductVariant',
            },
            {
              sku: 13661768,
              __typename: 'ProductVariant',
            },
            {
              sku: 13700316,
              __typename: 'ProductVariant',
            },
            {
              sku: 13905932,
              __typename: 'ProductVariant',
            },
          ],
          images: [
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/12116519-6795005564163856.jpg',
              __typename: 'ProductImage',
            },
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/12116519-1225004811424148.jpg',
              __typename: 'ProductImage',
            },
          ],
          brand: {
            name: 'Myprotein',
            __typename: 'Brand',
          },
          __typename: 'Product',
        },
        inStock: true,
        inWishlist: null,
        __typename: 'ProductVariant',
      },
      quantity: 1,
      chargePricePerUnit: {
        displayValue: '£16.99',
        amount: '16.99',
        __typename: 'MoneyValue',
      },
      standardPricePerUnit: {
        amount: '16.99',
        displayValue: '£16.99',
        __typename: 'MoneyValue',
      },
      totalChargePrice: {
        displayValue: '£16.99',
        amount: '16.99',
        __typename: 'MoneyValue',
      },
      totalStandardPrice: {
        displayValue: '£16.99',
        amount: '16.99',
        __typename: 'MoneyValue',
      },
      freeGift: false,
      totalDiscount: {
        displayValue: '£0.00',
        __typename: 'MoneyValue',
      },
      appliedOffers: [],
      messages: null,
      __typename: 'BasketItem',
    },
    {
      id: '13661778',
      fulfilmentMethod: null,
      product: {
        sku: 13661778,
        title:
          'Limited Edition Layered Protein Bar - Easter Egg - Limited Edition Easter Egg',
        maxPerOrder: null,
        product: {
          sku: 13661777,
          url:
            '/sports-nutrition/limited-edition-layered-protein-bar-easter-egg/13661777.html',
          variants: [
            {
              sku: 13661778,
              __typename: 'ProductVariant',
            },
            {
              sku: 13661780,
              __typename: 'ProductVariant',
            },
            {
              sku: 14218165,
              __typename: 'ProductVariant',
            },
          ],
          images: [
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/12748396-6094844604440280.jpg',
              __typename: 'ProductImage',
            },
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/12748396-1334844604487143.jpg',
              __typename: 'ProductImage',
            },
          ],
          brand: {
            name: 'Myprotein',
            __typename: 'Brand',
          },
          __typename: 'Product',
        },
        inStock: false,
        inWishlist: null,
        __typename: 'ProductVariant',
      },
      quantity: 1,
      chargePricePerUnit: {
        displayValue: '£27.99',
        amount: '27.99',
        __typename: 'MoneyValue',
      },
      standardPricePerUnit: {
        amount: '27.99',
        displayValue: '£27.99',
        __typename: 'MoneyValue',
      },
      totalChargePrice: {
        displayValue: '£27.99',
        amount: '27.99',
        __typename: 'MoneyValue',
      },
      totalStandardPrice: {
        displayValue: '£27.99',
        amount: '27.99',
        __typename: 'MoneyValue',
      },
      freeGift: false,
      totalDiscount: {
        displayValue: '£0.00',
        __typename: 'MoneyValue',
      },
      appliedOffers: [],
      messages: null,
      __typename: 'BasketItem',
    },
    {
      id: '11094929',
      fulfilmentMethod: null,
      product: {
        sku: 11094929,
        title: 'Protein Brownie - 12 x 75g - Chocolate',
        maxPerOrder: null,
        product: {
          sku: 11094927,
          url: '/sports-nutrition/protein-brownie/11094927.html',
          variants: [
            {
              sku: 11094929,
              __typename: 'ProductVariant',
            },
            {
              sku: 11214983,
              __typename: 'ProductVariant',
            },
            {
              sku: 11094928,
              __typename: 'ProductVariant',
            },
            {
              sku: 11214972,
              __typename: 'ProductVariant',
            },
          ],
          images: [
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/11094927-5614824894291165.jpg',
              __typename: 'ProductImage',
            },
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/11094927-1204923917672868.jpg',
              __typename: 'ProductImage',
            },
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/11094927-1114824894303336.jpg',
              __typename: 'ProductImage',
            },
            {
              largeProduct:
                'https://static.thcdn.com/productimg/300/300/11094927-2094824894192978.jpg',
              __typename: 'ProductImage',
            },
          ],
          brand: {
            name: 'Myprotein',
            __typename: 'Brand',
          },
          __typename: 'Product',
        },
        inStock: true,
        inWishlist: null,
        __typename: 'ProductVariant',
      },
      quantity: 1,
      chargePricePerUnit: {
        displayValue: '£11.49',
        amount: '11.49',
        __typename: 'MoneyValue',
      },
      standardPricePerUnit: {
        amount: '22.99',
        displayValue: '£22.99',
        __typename: 'MoneyValue',
      },
      totalChargePrice: {
        displayValue: '£11.49',
        amount: '11.49',
        __typename: 'MoneyValue',
      },
      totalStandardPrice: {
        displayValue: '£11.49',
        amount: '11.49',
        __typename: 'MoneyValue',
      },
      freeGift: false,
      totalDiscount: {
        displayValue: '£11.50',
        __typename: 'MoneyValue',
      },
      appliedOffers: [
        {
          totalBasketDiscount: {
            displayValue: '£11.50',
            __typename: 'MoneyValue',
          },
          message: "You've saved 50%",
          info: null,
          __typename: 'AppliedOffer',
        },
      ],
      messages: null,
      __typename: 'BasketItem',
    },
  ],
  chargePrice: {
    displayValue: '£56.47',
    amount: '56.47',
    __typename: 'MoneyValue',
  },
  messages: [
    {
      type: BasketMessageType.OfferApplied,
      message: "You've saved 50%",
      __typename: 'BasketMessage',
    },
    {
      type: BasketMessageType.SelectYourSampleApplied,
      message: '3 FREE gifts on all orders',
      __typename: 'BasketMessage',
    },
    {
      type: BasketMessageType.Upsell,
      message: 'Spend an additional &#163;8.53 for FREE UK Next Day Delivery',
      __typename: 'BasketMessage',
    },
    {
      type: BasketMessageType.ProductOutOfStock,
      message:
        'You have 1 or more errors in your bag. Please amend these before continuing.',
      __typename: 'BasketMessage',
    },
  ],
  recommendations: [
    {
      sku: 12590683,
      title: 'Pop Rolls',
      price: '£8.99',
      url: '/sports-nutrition/pop-rolls/12590683.html',
      image:
        'https://static.thcdn.com/productimg/300/300/12590683-1025018518504017.jpg',
      reviews: {
        total: 4.21,
        averageScore: 28,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 12128051,
      title: 'Layered Protein Bar (Sample)',
      price: '£2.99',
      url: '/sports-nutrition/layered-protein-bar-sample/12128051.html',
      image:
        'https://static.thcdn.com/productimg/300/300/12128051-8955004813817956.jpg',
      reviews: {
        total: 4.46,
        averageScore: 220,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 11691950,
      title: 'Protein Spreads',
      price: '£6.99',
      url: '/sports-nutrition/protein-spreads/11691950.html',
      image:
        'https://static.thcdn.com/productimg/300/300/11691951-8324824869276820.jpg',
      reviews: {
        total: 4.59,
        averageScore: 352,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 10530743,
      title: 'All-Natural Peanut Butter',
      price: '£2.99',
      url: '/sports-nutrition/all-natural-peanut-butter/10530743.html',
      image:
        'https://static.thcdn.com/productimg/300/300/10530743-1564859351688231.jpg',
      reviews: {
        total: 4.71,
        averageScore: 2558,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
  ],
  selectYourSample: [
    {
      id: '1031478',
      title: null,
      message: '3 FREE gifts on all orders',
      currentAmountSpent: {
        displayValue: '£56.47',
        amount: '56.47',
        __typename: 'MoneyValue',
      },
      tiers: [
        {
          id: '1031478:0',
          isFullyOutOfStock: false,
          isPartiallyOutOfStock: false,
          additionalSpendToReach: {
            displayValue: '£0.00',
            amount: '0.00',
            __typename: 'MoneyValue',
          },
          thresholdAmountSpent: {
            displayValue: '£0.01',
            __typename: 'MoneyValue',
          },
          products: [
            {
              images: [
                {
                  thumbnail:
                    'https://static.thcdn.com/productimg/70/70/12770626-2355005295106384.jpg',
                  largeProduct:
                    'https://static.thcdn.com/productimg/300/300/12770626-2355005295106384.jpg',
                  zoom:
                    'https://static.thcdn.com/productimg/960/960/12770626-2355005295106384.jpg',
                  __typename: 'ProductImage',
                },
              ],
              title: 'Fiit - One month free + 25% off',
              sku: 12770626,
              content: [
                {
                  key: 'range',
                  value: {
                    value: ['Other'],
                    __typename: 'ProductContentStringListValue',
                  },
                  __typename: 'ProductContentItem',
                },
                {
                  key: 'brand',
                  value: {
                    value: ['FiiT TV'],
                    __typename: 'ProductContentStringListValue',
                  },
                  __typename: 'ProductContentItem',
                },
                {
                  key: 'synopsis',
                  value: {
                    value: [
                      {
                        content: [
                          {
                            content:
                              "<p>Get 1000+ workouts and 20+ training plans all designed to turn you into an athletic weapon.&nbsp;</p> \n<p>Led by world-class trainers, choose from functional fitness, AssaultBike workouts, HIIT, strength, yoga, pilates and more.</p> \n<p>Plus, tap into all the data and sports science when you connect your fitness tracker – including Apple Watch, Fitbit, MyZone and more.&nbsp;</p> \n<p>Available on iOS, Android, Sky Q and Amazon Fire TV.</p> \n<p>T&amp;C:&nbsp; *Your first 30 days are totally free! You’ll then be charged monthly (£20) or yearly (£120) with 25% off your first payment. You'll receive an email 48 hours before payment is taken. Subscription renews automatically unless you cancel. You can cancel anytime. Terms of use can be found here.</p> \n<p>The 25% discount will be applied to your first payment only, and is applicable to all subtypes.</p>",
                            type: RichContentType.Html,
                            __typename: 'RichContentItem',
                          },
                        ],
                        __typename: 'RichContent',
                      },
                    ],
                    __typename: 'ProductContentRichContentListValue',
                  },
                  __typename: 'ProductContentItem',
                },
              ],
              descriptionContent: {
                items: [
                  {
                    key: 'synopsis',
                    titleKey: 'synopsis',
                    content:
                      "<p>Get 1000+ workouts and 20+ training plans all designed to turn you into an athletic weapon.&nbsp;</p> \n<p>Led by world-class trainers, choose from functional fitness, AssaultBike workouts, HIIT, strength, yoga, pilates and more.</p> \n<p>Plus, tap into all the data and sports science when you connect your fitness tracker – including Apple Watch, Fitbit, MyZone and more.&nbsp;</p> \n<p>Available on iOS, Android, Sky Q and Amazon Fire TV.</p> \n<p>T&amp;C:&nbsp; *Your first 30 days are totally free! You’ll then be charged monthly (£20) or yearly (£120) with 25% off your first payment. You'll receive an email 48 hours before payment is taken. Subscription renews automatically unless you cancel. You can cancel anytime. Terms of use can be found here.</p> \n<p>The 25% discount will be applied to your first payment only, and is applicable to all subtypes.</p>",
                    __typename: 'ProductDescriptionItem',
                  },
                ],
                details: [
                  {
                    key: 'range',
                    titleKey: 'range',
                    value: 'Other',
                    __typename: 'ProductDescriptionDetail',
                  },
                  {
                    key: 'brand',
                    titleKey: 'brand',
                    value: 'FiiT TV',
                    __typename: 'ProductDescriptionDetail',
                  },
                ],
                videoTitle: null,
                videoReference: null,
                deliveryTitle: null,
                provenance: {
                  enabled: false,
                  textItem: null,
                  __typename: 'ProductDescriptionProvenance',
                },
                __typename: 'ProductDescription',
              },
              inStock: true,
              __typename: 'ProductVariant',
            },
            {
              images: [
                {
                  thumbnail:
                    'https://static.thcdn.com/productimg/70/70/13898795-1915020292485887.jpg',
                  largeProduct:
                    'https://static.thcdn.com/productimg/300/300/13898795-1915020292485887.jpg',
                  zoom:
                    'https://static.thcdn.com/productimg/960/960/13898795-1915020292485887.jpg',
                  __typename: 'ProductImage',
                },
              ],
              title: 'SimplyCook - Free Box!',
              sku: 13898795,
              content: [
                {
                  key: 'brand',
                  value: {
                    value: ['SimplyCook'],
                    __typename: 'ProductContentStringListValue',
                  },
                  __typename: 'ProductContentItem',
                },
                {
                  key: 'synopsis',
                  value: {
                    value: [
                      {
                        content: [
                          {
                            content:
                              '<p>Rediscover the simple pleasures of home cooking</p> \n<p>SimplyCook is your new helping hand in the kitchen that makes cooking simply delicious, affordable and flexible.</p> \n<ul> \n <li>Recipe kits enable you to SimplyCook 140+ chef-created recipes in half an hour or less.</li> \n <li>Each kit comes with 3 pots of pleasure, packed with up to 23 ingredients, adding extraordinary flavour to your meals.</li> \n <li>Join 100,000+ happy home cooks, who’ve enjoyed 50 million meals (and counting).</li> \n <li>Try your first box for free (just pay £1 postage) and rediscover midweek cooking with a new ingredient: pleasure.</li> \n</ul>',
                            type: RichContentType.Html,
                            __typename: 'RichContentItem',
                          },
                        ],
                        __typename: 'RichContent',
                      },
                    ],
                    __typename: 'ProductContentRichContentListValue',
                  },
                  __typename: 'ProductContentItem',
                },
              ],
              descriptionContent: {
                items: [
                  {
                    key: 'synopsis',
                    titleKey: 'synopsis',
                    content:
                      '<p>Rediscover the simple pleasures of home cooking</p> \n<p>SimplyCook is your new helping hand in the kitchen that makes cooking simply delicious, affordable and flexible.</p> \n<ul> \n <li>Recipe kits enable you to SimplyCook 140+ chef-created recipes in half an hour or less.</li> \n <li>Each kit comes with 3 pots of pleasure, packed with up to 23 ingredients, adding extraordinary flavour to your meals.</li> \n <li>Join 100,000+ happy home cooks, who’ve enjoyed 50 million meals (and counting).</li> \n <li>Try your first box for free (just pay £1 postage) and rediscover midweek cooking with a new ingredient: pleasure.</li> \n</ul>',
                    __typename: 'ProductDescriptionItem',
                  },
                ],
                details: [
                  {
                    key: 'brand',
                    titleKey: 'brand',
                    value: 'SimplyCook',
                    __typename: 'ProductDescriptionDetail',
                  },
                ],
                videoTitle: null,
                videoReference: null,
                deliveryTitle: null,
                provenance: {
                  enabled: false,
                  textItem: null,
                  __typename: 'ProductDescriptionProvenance',
                },
                __typename: 'ProductDescription',
              },
              inStock: true,
              __typename: 'ProductVariant',
            },
            {
              images: [
                {
                  thumbnail:
                    'https://static.thcdn.com/productimg/70/70/13438111-2034998822694365.jpg',
                  largeProduct:
                    'https://static.thcdn.com/productimg/300/300/13438111-2034998822694365.jpg',
                  zoom:
                    'https://static.thcdn.com/productimg/960/960/13438111-2034998822694365.jpg',
                  __typename: 'ProductImage',
                },
              ],
              title:
                'The Supplement: Self Care Digital Edition + Digital Subscription',
              sku: 13438111,
              content: [
                {
                  key: 'brand',
                  value: {
                    value: ['Myprotein'],
                    __typename: 'ProductContentStringListValue',
                  },
                  __typename: 'ProductContentItem',
                },
                {
                  key: 'range',
                  value: {
                    value: ['Other'],
                    __typename: 'ProductContentStringListValue',
                  },
                  __typename: 'ProductContentItem',
                },
                {
                  key: 'synopsis',
                  value: {
                    value: [
                      {
                        content: [
                          {
                            content:
                              '<p>It’s time to put you first. That’s why this edition of The Supplement focuses on self care.</p> \n<p>Meet our cover stars, Lex Griffin and Rachel John, two fitness pros who inspire their followers with positivity and encourage a balanced lifestyle.&nbsp;</p> \n<p>Check out exercises to help boost your physical and mental health as well as budget kitchen recipes that deliver on nutrition but don’t break the bank.&nbsp;</p> \n<p>And of course, we get Richie Kirwan, our resident nutrition expert, to answer your questions and break down the latest research into terms we can all understand.</p> \n<p>Here’s what to expect from the Self Care&nbsp;Edition:</p> \n<ul> \n <li>Meet rising influencer Fatima Unia</li> \n <li>Tackle gut health with Jamie Wright</li> \n <li>Get in the mood with our Warm Up and Cool Down playlists</li> \n <li>Q&amp;A with pro boxer Viddal Riley&nbsp;</li> \n <li>The Rogue Ramblers’ top five UK walks</li> \n <li>Interview with MYP/PT Sean Butt</li> \n <li>Expert’s guide to skincare for all skin types</li> \n <li>DOMS explained</li> \n</ul> \n<p>Plus, by claiming your copy of The Supplement, you’ll also get a free digital subscription to our quarterly issue!&nbsp;</p>',
                            type: RichContentType.Html,
                            __typename: 'RichContentItem',
                          },
                        ],
                        __typename: 'RichContent',
                      },
                    ],
                    __typename: 'ProductContentRichContentListValue',
                  },
                  __typename: 'ProductContentItem',
                },
              ],
              descriptionContent: {
                items: [
                  {
                    key: 'synopsis',
                    titleKey: 'synopsis',
                    content:
                      '<p>It’s time to put you first. That’s why this edition of The Supplement focuses on self care.</p> \n<p>Meet our cover stars, Lex Griffin and Rachel John, two fitness pros who inspire their followers with positivity and encourage a balanced lifestyle.&nbsp;</p> \n<p>Check out exercises to help boost your physical and mental health as well as budget kitchen recipes that deliver on nutrition but don’t break the bank.&nbsp;</p> \n<p>And of course, we get Richie Kirwan, our resident nutrition expert, to answer your questions and break down the latest research into terms we can all understand.</p> \n<p>Here’s what to expect from the Self Care&nbsp;Edition:</p> \n<ul> \n <li>Meet rising influencer Fatima Unia</li> \n <li>Tackle gut health with Jamie Wright</li> \n <li>Get in the mood with our Warm Up and Cool Down playlists</li> \n <li>Q&amp;A with pro boxer Viddal Riley&nbsp;</li> \n <li>The Rogue Ramblers’ top five UK walks</li> \n <li>Interview with MYP/PT Sean Butt</li> \n <li>Expert’s guide to skincare for all skin types</li> \n <li>DOMS explained</li> \n</ul> \n<p>Plus, by claiming your copy of The Supplement, you’ll also get a free digital subscription to our quarterly issue!&nbsp;</p>',
                    __typename: 'ProductDescriptionItem',
                  },
                ],
                details: [
                  {
                    key: 'brand',
                    titleKey: 'brand',
                    value: 'Myprotein',
                    __typename: 'ProductDescriptionDetail',
                  },
                  {
                    key: 'range',
                    titleKey: 'range',
                    value: 'Other',
                    __typename: 'ProductDescriptionDetail',
                  },
                ],
                videoTitle: null,
                videoReference: null,
                deliveryTitle: null,
                provenance: {
                  enabled: false,
                  textItem: null,
                  __typename: 'ProductDescriptionProvenance',
                },
                __typename: 'ProductDescription',
              },
              inStock: true,
              __typename: 'ProductVariant',
            },
          ],
          selectedProducts: [],
          maxSelectedProducts: 3,
          __typename: 'SelectYourSampleTier',
        },
      ],
      __typename: 'SelectYourSample',
    },
  ],
  availablePaymentOptions: [
    {
      icon: PaymentIcon.KLARNA,
      type: PaymentType.KLARNA,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.KLARNA,
      type: PaymentType.KLARNA_LATER,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.PAYPAL,
      type: PaymentType.PAYPAL,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.PAYPAL_IN_3,
      type: PaymentType.PAYPAL_IN_3,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.CLEAR_PAY,
      type: PaymentType.CLEAR_PAY,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.LAY_BUY,
      type: PaymentType.LAY_BUY,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.PAYVYNE,
      type: PaymentType.PAYVYNE,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.MODE,
      type: PaymentType.MODE,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.SPLIT_IT,
      type: PaymentType.SPLIT_IT,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.GOOGLE_PAY,
      type: PaymentType.GOOGLE_PAY,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
    {
      icon: PaymentIcon.APPLE_PAY,
      type: PaymentType.APPLE_PAY,
      subType: null,
      __typename: 'AvailablePaymentOption',
    },
  ],
  hasProductWithClickAndCollectFulfilment: true,
  earnableLoyaltyPoints: null,
  __typename: 'Basket',
}

export const Basket = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_: any, args: BasketVariables): Promise<BasketData> => {
  if (behaviours.override) {
    return BASKET_MOCK
  }

  const { data } = await client.query({
    query,
    variables: args,
  })

  return normaliseBasket(data.basket, args.productDescriptionKeys)
}
